import { Compensation } from 'types';
import { UserPermissions } from 'store';
import { CompensationStatus } from 'enums';

import { CompensationEditMode } from '../enums';

export const getCompensationAvailableEditMode = (
  { status }: Compensation,
  isAccountPage: boolean,
  permissions: UserPermissions,
): CompensationEditMode => {
  if (status === CompensationStatus.Closed) {
    return CompensationEditMode.None;
  }

  if (isAccountPage && (status === CompensationStatus.UpdateRequired || status === CompensationStatus.Pending)) {
    return CompensationEditMode.User;
  }

  if (permissions.hasAdministratorPermission) {
    return CompensationEditMode.Admin;
  }

  if (permissions.hasManageCompensationsPermission && status === CompensationStatus.Pending) {
    return CompensationEditMode.Manager;
  }

  return CompensationEditMode.None;
};
